// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__28oeA","messages":"Chat_messages__p_nsC","dateDivider":"Chat_dateDivider__23giM"};